import { tryOnScopeDispose as a } from "../../../../@vueuse_shared@10.5.0_vue@3.3.4/node_modules/@vueuse/shared/index.js";
import { ref as i } from "vue";
import g from "../../../../universal-cookie@6.1.1/node_modules/universal-cookie/es6/Cookies.js";
function d(r, { doNotParse: n = !1, autoUpdateDependencies: u = !1 } = {}, t = new g()) {
  const l = u ? [...r || []] : r;
  let f = t.getAll({ doNotParse: !0 });
  const o = i(0), s = () => {
    const e = t.getAll({ doNotParse: !0 });
    h(
      l || null,
      e,
      f
    ) && o.value++, f = e;
  };
  return t.addChangeListener(s), a(() => {
    t.removeChangeListener(s);
  }), {
    /**
     * Reactive get cookie by name. If **autoUpdateDependencies = true** then it will update watching dependencies
     */
    get: (...e) => (u && l && !l.includes(e[0]) && l.push(e[0]), o.value, t.get(e[0], { doNotParse: n, ...e[1] })),
    /**
     * Reactive get all cookies
     */
    getAll: (...e) => (o.value, t.getAll({ doNotParse: n, ...e[0] })),
    set: (...e) => t.set(...e),
    remove: (...e) => t.remove(...e),
    addChangeListener: (...e) => t.addChangeListener(...e),
    removeChangeListener: (...e) => t.removeChangeListener(...e)
  };
}
function h(r, n, u) {
  if (!r)
    return !0;
  for (const t of r)
    if (n[t] !== u[t])
      return !0;
  return !1;
}
export {
  d as useCookies
};
